export default {"src":"/_next/static/media/firekit.2b4f7fd9.svg","height":50,"width":50};